import React from 'react';
import UserCard from '../ProfileCard';
import ReactDOM from 'react-dom'
import jump from 'jump.js'
import { Link } from 'react-router-dom';
import * as RT from '../../../constants/Routing'
import defaultUserThumb from '../../../lib/images/user-thumb-default.png'
// import anchorify from 'anchorify'
import AnchorifyText from 'react-anchorify-text'
import moment from 'moment/min/moment-with-locales';
moment.locale('ja')


export default class Component extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      messageContent: '',
      firstLoad: false
    }
  }

  nl2br = (text) => {
    var regex = /(\r\n|\n|\r)/gm
    return text.split(regex).map(function (line) {
      if (line.match(regex)) {
        return React.createElement('br')
      }
      else {
        return (
          <AnchorifyText text={line} target='_blank'></AnchorifyText>
        )
        // return anchorify(line, {target: '_blank'});
      }
    });
  }

  valueChange = (e) => {
    // this.resize()
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  sendMessage = () => {
    if (!!this.state.messageContent) {
      this.props.sendMessage(this.state.messageContent, this.props.match.params.id)
      this.setState({ messageContent: '' })
    }
  }

  componentWillMount = () => {
    const anotherUserId = this.props.match.params.id
    this.props.getChats(anotherUserId)
  }

  componentDidMount = () => {
    
  }

  initMessages = () => {
    const target = document.querySelector('.messageItemWrap:last-of-type')
    if (target) {
      jump(target)
    }
    document.getElementById('panel').classList.add('messageMain')
  }

  componentWillUnmount = () => {
    document.getElementById('panel').classList.remove('messageMain')
    this.props.getChatsReset()
  }


  componentDidUpdate = () => {
    const userMessages = this.props.UserMessages
    if (userMessages.selectedMessages) {
      const messagesProps = this.props.UserMessages.selectedMessages
      if (messagesProps) {
        if (messagesProps) {
          let hasUnread = false
          for (let index = 0; index < messagesProps.length; index++) {
            const elm = messagesProps[index];
            if (elm.unread) {
              hasUnread = true
              break;
            }
          }
          if (hasUnread) {
            this.props.readAllMessage(this.props.UserMessages.messagesPartner.id)
          }
        }
      }
    }

    if (!this.state.firstLoad && this.props.UserMessages && this.props.UserMessages.messagesPartner) {
      const target = document.querySelector('.messageItemWrap:last-of-type')
      this.initMessages()
      this.setState({ firstLoad: true })
    }
  }

  componentWillReceiveProps = (nextProps) => {

  }



  render = () => {
    const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname
    let messagesField
    if (!!this.state.messageContent) {
      messagesField = (
        <div className='messageFormFieldWrap'>
          <textarea id='messageFormField' type="text" name='messageContent' value={this.state.messageContent} onChange={this.valueChange} />
          <i className="material-icons sendBtn" onClick={this.sendMessage}>send</i>
        </div>
      )
    } else {
      messagesField = (
        <div className='messageFormFieldWrap'>
          <textarea id='messageFormField' type="text" name='messageContent' value={this.state.messageContent} onChange={this.valueChange} />
          <i className="material-icons sendBtn disabled" onClick={this.sendMessage}>send</i>
        </div>
      )
    }
    

    const messages = this.props.UserMessages.selectedMessages
    let messageBody
    if (messages) {
      messageBody = messages.map(message => {

        // if (currentUser.name === message.name) {

        // }
        let photo = defaultUserThumb
        let readNotice
        let myMessage = message.sender_id === currentUser.id
        if (!message.unread && myMessage) { // TODO 自分のメッセージのみ
          readNotice = (
            <span className='messageRead'>既読</span>
          )
        }

        if (myMessage) {
          if (currentUser.photo) {
            photo = currentUser.photo
          }
        } else {
          const partner = this.props.UserMessages.messagesPartner
          if (partner && partner.photo) {
            photo = partner.photo
          }
        }
        return (
          <div key={message.id} className={'messageItemWrap clearfix' + (myMessage ? ' self' : ' others')}>
            <div className='messageItem'>
              <p>{this.nl2br(message.content)}</p>
            </div>
            <Link to={RT.USER_SHOW_PATH.replace(/:id/, currentUser.id)}>
              <div className='userThumb' style={{ backgroundImage: `url(${photo})` }}></div>
            </Link>
            <span className='messageDate'>{moment(message.delivered_at).fromNow()}</span>
            {readNotice}
          </div>
        )
      })
    } else {
      <div>メッセージはありません。</div>
    }
    
    return (
      <div className='container'>
        {ReactDOM.createPortal(messagesField, document.getElementById('fixedBottomWrap'))}
        <div className='messagesWrap'>
          {messageBody}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/MessageRoom/MessageRoom.jsx